var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConfirmed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.47C13.1256 16.47 16.47 13.1256 16.47 9C16.47 4.87443 13.1256 1.53 9 1.53C4.87443 1.53 1.53 4.87443 1.53 9C1.53 13.1256 4.87443 16.47 9 16.47ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#43B75D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 6.54965L10.7483 9.10115L8.19675 11.6527C8.07075 11.7787 7.89975 11.8507 7.71975 11.8507C7.53975 11.8507 7.36875 11.7787 7.24275 11.6527L4.69575 9.10565C4.43475 8.84465 4.43475 8.41265 4.69575 8.15165C4.95675 7.89065 5.38875 7.89065 5.64975 8.15165L7.71975 10.2217L12.3458 5.59565C12.6068 5.33465 13.0388 5.33465 13.2998 5.59565C13.5608 5.85665 13.5608 6.27965 13.2998 6.54965Z",
    fill: "#43B75D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfirmed);
export default __webpack_public_path__ + "static/media/iconConfirmed.20f1ac16cb76aa6d82ccb6031d0858c8.svg";
export { ForwardRef as ReactComponent };